import React from 'react'

const PscreenHeader = ({ psc, police, nig_logo, applicationResults, activeTab }: any) => {
  return (
   <div>
                 <div className='pscreen-header pt-5'>
                   <div className=' bg-primary rounded-top pt-5'>
                     <div className=' w-100 float-left p-4 border-0 section-header-bg'>
                       <div className='row h-100'>
                         <div className='col-sm-3 my-auto text-center d-block d-lg-none'>
                           <div className='d-flex px-5 position-relative v-w'>
                             <div className='logo-style'>
                               <img
                                 src={psc}
                                 width={60}
                                 height={60}
                                 className='rounded-pill'
                               />
                               <img
                                 src={police}
                                 width={60}
                                 height={60}
                                 className='rounded-pill'
                               />
                             </div>
                             <div>
                               <img
                                 src={nig_logo}
                                 width={150}
                                 height={150}
                                 className='rounded-pill ms-3'
                               />
                             </div>
                           </div>
                         </div>
                         <div className='col-sm-3 my-auto text-center d-none d-lg-block'>
                           <img
                             className='img-responsive border border-white rounded'
                             width='120'
                             height='120'
                             src={`${applicationResults.photo || ''}`}
                           />
                         </div>
                         <div className='col-sm-6 my-auto text-center'>
                           <h2 className='text-light mb-3'>
                             {' '}
                             2025 Nigeria Police Force Recruitment
                           </h2>
                           <h2 className='text-light mb-3'>
                             {' '}
                            {
                            activeTab === 'physical' && <>Physical Screening Form</>}
                            {activeTab === 'academic' && <>Credential Screening Form</>}
                            {activeTab === 'screening4' && <>Physical / Credentials Screening Invitation</>
                            }
                           </h2>
                         </div>
                         <div className='col-sm-3 my-auto text-center d-block d-lg-none'>
                           <img
                             className='img-responsive border border-white rounded'
                             width='120'
                             height='120'
                             src={`${applicationResults.photo || ''}`}
                           />
                         </div>
                         <div className='col-sm-3 my-auto text-center d-none  d-lg-block'>
                           <div className='d-flex px-5 position-relative v-w'>
                             <div className='logo-style d-flex'>
                               <img
                                 src={psc}
                                 width={60}
                                 height={60}
                                 className='rounded-pill'
                               />
                               <img
                                 src={police}
                                 width={60}
                                 height={60}
                                 className='rounded-pill'
                               />
                             </div>
                             <div>
                               <img
                                 src={nig_logo}
                                 width={150}
                                 height={150}
                                 className='rounded-pill ms-3'
                               />
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
  )
}
export default PscreenHeader
